import React, { useState } from "react";
import { Languages } from "@wuilt/ui-components";
import { FormattedMessage } from "react-intl";
import DropDown from "../components/DropDwon";
import classnames from "classnames";
import styles from "./LanguageSwitcher.module.scss";
import { languages as languagesData } from "./languages";
import useElements from "../hooks/useElements";
import DropArrowIcon from "./DropArrowIcon";

export interface LanguageSwitcherProps {
  dropDownClass: string;
  displayClass: string;
  labelClass: string;
  iconClass: string;
  showDivider: boolean;
  withIcon: boolean;
  withLabel: boolean;
  dropTo: "top" | "down";
  languages: { iso: string; active: boolean; link: string }[];
  noAction?: boolean;
}

function LanguageSwitcher(props: LanguageSwitcherProps) {
  const [isShowOptions, setShowOptions] = useState(false);
  const { base } = useElements();
  const Link = base?.Link;
  const {
    displayClass,
    dropTo,
    withLabel,
    labelClass,
    withIcon,
    iconClass,
    languages,
    dropDownClass,
    showDivider = true,
    noAction,
  } = props;

  const LinkComponent = noAction ? "div" : Link;

  const renderDropDown = (direction: "up" | "down") => {
    const classes = classnames({
      [styles.dropDown]: true,
      [styles.dropDirectionUp]: direction === "up",
    });

    return (
      <div className={classes}>
        <DropDown
          direction={direction}
          className={dropDownClass}
          id="inputGroupSelect01"
          visible={isShowOptions}
        >
          {languages.map((language) => (
            <DropDown.Item key={language.iso} selected={language.active}>
              <LinkComponent
                className={styles.languageLink}
                href={language.link}
                // onClick={(e) => {
                // e.preventDefault();
                // onChangeEditorLocale(language);
                // }}
              >
                {languagesData[language.iso].name}
              </LinkComponent>
            </DropDown.Item>
          ))}
        </DropDown>
      </div>
    );
  };

  const isOpenToTop = dropTo === "top";
  if (languages.length === 1) {
    return null;
  }
  const activeLanguage = languages.find((language) => language.active);
  const classes = classnames(styles.wrapper, displayClass);
  const dropArrowClasses = classnames({
    [styles.dropArrow]: true,
    [styles.dropDirectionUp]: isOpenToTop,
  });
  return (
    <div className={styles.styledFlex}>
      {showDivider && <span className={styles.divider} />}
      <div className={classes} onMouseLeave={() => setShowOptions(false)}>
        {isOpenToTop && renderDropDown("up")}
        <div
          className={classnames(styles.labelWrapper, labelClass)}
          onMouseEnter={() => setShowOptions(true)}
        >
          {withIcon && <i className={`la la-${withIcon} ${iconClass}`} />}
          {withLabel && (
            <span>
              <FormattedMessage defaultMessage="Language:" id="fiNfmb" />
            </span>
          )}
          <div className={styles.styledFlex}>
            <Languages size="22px" className={styles.languagesIcon} />
            <span className={styles.languageName}>
              {languagesData[activeLanguage?.iso!].name}
            </span>
          </div>
          <DropArrowIcon dropArrowClasses={dropArrowClasses} />
        </div>
        {!isOpenToTop && renderDropDown("down")}
      </div>
    </div>
  );
}

export default LanguageSwitcher;
